import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Mail } from 'lucide-react';
import { useAvailableTemplates } from '../../../hooks/useReservationComms';
import SendPreviewModal from './SendPreviewModal';

function SendNowDropdown({ reservationId, context }) {
  const { templateCategories, isLoading } = useAvailableTemplates(reservationId);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const dropdownRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  // Close on Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen]);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setIsOpen(false);
  };

  const truncate = (str, length = 50) => {
    if (!str) return '';
    return str.length > length ? str.substring(0, length) + '...' : str;
  };

  return (
    <div className="send-now-dropdown" ref={dropdownRef}>
      <button
        className="btn btn-primary send-now-btn"
        onClick={() => setIsOpen(!isOpen)}
        disabled={isLoading}
      >
        <Mail size={16} />
        Send Email
        <ChevronDown size={16} />
      </button>

      {isOpen && (
        <div className="send-now-dropdown-menu">
          {isLoading ? (
            <div className="send-now-loading">Loading templates...</div>
          ) : templateCategories.length === 0 ? (
            <div className="send-now-empty">No templates available</div>
          ) : (
            templateCategories.map((category) => (
              <div key={category.category} className="send-now-category">
                <div className="send-now-category-header">{category.category}</div>
                {category.templates.map((template) => (
                  <button
                    key={template.id}
                    className="send-now-template-item"
                    onClick={() => handleTemplateSelect(template)}
                  >
                    <div className="send-now-template-name">{template.name}</div>
                    <div className="send-now-template-subject">
                      {truncate(template.subject_tpl)}
                    </div>
                  </button>
                ))}
              </div>
            ))
          )}
        </div>
      )}

      {selectedTemplate && (
        <SendPreviewModal
          reservationId={reservationId}
          template={selectedTemplate}
          context={context}
          onClose={() => setSelectedTemplate(null)}
        />
      )}
    </div>
  );
}

export default SendNowDropdown;
